import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/saif-dc/DC/projects/react-node-js/ucb/components/career/CareerList.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/saif-dc/DC/projects/react-node-js/ucb/components/career/Desc.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/saif-dc/DC/projects/react-node-js/ucb/components/InnerBanner.jsx");
